import styled from 'styled-components';

export const FooterSummaryTitle = styled.th`
  font-weight: bold !important;
`;
